// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M12.707 15.707l-.094.083a1 1 0 0 1-1.32-.083h0l-6-6-.083-.094a1 1 0 0 1 1.497-1.32h0L12 13.585l5.293-5.292.094-.083a1 1 0 0 1 1.32 1.497h0l-6 6z%27 fill=%27%236f767e%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rsF2XXPPwXh2xLrqYz5e {
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #33383F;
}
.dark-mode .rsF2XXPPwXh2xLrqYz5e {
  color: #EFEFEF;
}

.x5SeUnqbgpvFrLCeoRwh {
  position: relative;
  top: -1px;
}
.x5SeUnqbgpvFrLCeoRwh svg {
  fill: #9A9FA5;
}

.rpd6Y0WB6Ya5FG48j17Z {
  position: relative;
  z-index: 3;
}
.rpd6Y0WB6Ya5FG48j17Z.cil3By3nTVZfoiJ3U4GY {
  z-index: 10;
}
.rpd6Y0WB6Ya5FG48j17Z.cil3By3nTVZfoiJ3U4GY .W7YKvFicQS1yIIdCrxuC {
  box-shadow: inset 0 0 0 2px #9A9FA5;
  background: #FFFFFF;
}
.dark-mode .rpd6Y0WB6Ya5FG48j17Z.cil3By3nTVZfoiJ3U4GY .W7YKvFicQS1yIIdCrxuC {
  box-shadow: inset 0 0 0 2px #33383F;
  background: #111315;
  color: #FCFCFC;
}

.rpd6Y0WB6Ya5FG48j17Z.cil3By3nTVZfoiJ3U4GY .W7YKvFicQS1yIIdCrxuC:before {
  transform: rotate(180deg);
}
.rpd6Y0WB6Ya5FG48j17Z.cil3By3nTVZfoiJ3U4GY .v1n0CB6Bacz5cZtVavC0 {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}
.rpd6Y0WB6Ya5FG48j17Z.i0PklF3twvLev7vQ8jOR .W7YKvFicQS1yIIdCrxuC {
  height: 40px;
  padding: 0 40px 0 16px;
  line-height: 40px;
}
.rpd6Y0WB6Ya5FG48j17Z.i0PklF3twvLev7vQ8jOR .W7YKvFicQS1yIIdCrxuC:before {
  width: 40px;
  background-size: 16px auto;
}
.rpd6Y0WB6Ya5FG48j17Z.i0PklF3twvLev7vQ8jOR .PkJzM8GGNychNJ_wCKTs {
  padding: 4px 16px;
}

.W7YKvFicQS1yIIdCrxuC {
  position: relative;
  height: 48px;
  padding: 0 48px 0 12px;
  border-radius: 12px;
  box-shadow: inset 0 0 0 2px #EFEFEF;
  font-size: 14px;
  font-weight: 600;
  line-height: 48px;
  color: #1A1D1F;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  user-select: none;
  transition: all 0.2s;
}
.W7YKvFicQS1yIIdCrxuC:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 48px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/24px auto;
  transition: transform 0.2s;
}
.W7YKvFicQS1yIIdCrxuC:hover {
  box-shadow: inset 0 0 0 2px #9A9FA5;
}
.dark-mode .W7YKvFicQS1yIIdCrxuC {
  box-shadow: inset 0 0 0 2px #272B30;
  background: none;
  color: #6F767E;
}
.dark-mode .W7YKvFicQS1yIIdCrxuC:hover {
  box-shadow: inset 0 0 0 2px #33383F;
}

.TwVup4u8xMLxzY2fNegB {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v1n0CB6Bacz5cZtVavC0 {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  padding: 8px 0;
  border-radius: 12px;
  background: #FFFFFF;
  box-shadow: inset 0 0 0 2px #EFEFEF, 0 4px 12px rgba(244, 244, 244, 0.1);
  visibility: hidden;
  opacity: 0;
  transform: translateY(3px);
  transition: all 0.2s;
}
.dark-mode .v1n0CB6Bacz5cZtVavC0 {
  background: #111315;
  box-shadow: inset 0 0 0 2px #33383F, 0 4px 12px rgba(17, 19, 21, 0.1);
}

.v1n0CB6Bacz5cZtVavC0.LlBp5xTO5y1Pd6qM2BhW {
  top: auto;
  bottom: calc(100% + 2px);
}

.PkJzM8GGNychNJ_wCKTs {
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #6F767E;
  transition: color 0.2s;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.PkJzM8GGNychNJ_wCKTs:hover {
  color: #1A1D1F;
}
.dark-mode .PkJzM8GGNychNJ_wCKTs:hover {
  color: #FCFCFC;
}

.PkJzM8GGNychNJ_wCKTs.tOQUCxTqXhV5MIAHEwSy {
  color: #2A85FF;
}
.dark-mode .PkJzM8GGNychNJ_wCKTs.tOQUCxTqXhV5MIAHEwSy {
  color: #2A85FF;
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,mBAAA;ECqFA,eAAA;EACA,gBAAA;EACA,yBAAA;EDrFA,cCwCC;ADvCL;ACsLa;EDrLL,cCoCH;ADlCL;;AAAA;EACI,kBAAA;EACA,SAAA;AAGJ;AAFI;EACI,aCqCE;ADjCV;;AAFA;EACI,kBAAA;EACA,UAAA;AAKJ;AAJI;EACI,WAAA;AAMR;AALQ;EACI,mCAAA;EACA,mBCkBR;ADXJ;AC+Ja;EDpKG,mCAAA;EACA,mBCuBX;EDtBW,cCeX;ADPL;;AAPY;EACI,yBAAA;AAUhB;AATQ;EACI,mBAAA;EACA,UAAA;EACA,wBAAA;AAWZ;AATQ;EACI,YAAA;EACA,sBAAA;EACA,iBAAA;AAWZ;AAVY;EACI,WAAA;EACA,0BAAA;AAYhB;AAXQ;EACI,iBAAA;AAaZ;;AAXA;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCNC;EDOD,eAAA;EACA,6CAAA;EACA,iBAAA;EACA,oBAAA;AAcJ;AAbI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,+EAAA;EACA,0BAAA;AAeR;AAdI;EACI,mCAAA;AAgBR;ACwGa;EDtHL,mCAAA;EACA,gBAAA;EACA,cC5BH;AD6CL;AAhBQ;EACI,mCAAA;AAkBZ;;AAhBA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAmBJ;;AAjBA;EACI,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,mBChDA;EDiDA,wEAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,oBAAA;AAoBJ;AC2Ea;ED7FL,mBC/CH;EDgDG,qEAAA;AAqBR;;AApBI;EACI,SAAA;EACA,wBAAA;AAuBR;;AArBA;EACI,iBAAA;ECdA,eAAA;EACA,gBAAA;EACA,yBAAA;EDcA,cC5DC;ED6DD,sBAAA;EACA,eAAA;EACA,6CAAA;AA0BJ;AAzBI;EACI,cC9DH;ADyFL;ACoDa;ED7ED,cCtEP;ADkGL;;AA3BI;EACI,cCnFH;ADiHL;AC6Ca;EDzED,cCrFP;ADoHL","sourcesContent":["@import ../../styles/helpers\n\n.label\n    margin-bottom: 14px\n    +base2\n    color: $n5\n    +dark\n        color: $n3\n\n.tooltip\n    position: relative\n    top: -1px\n    svg\n        fill: $shades1\n\n.dropdown\n    position: relative\n    z-index: 3\n    &.active\n        z-index: 10\n        .head\n            box-shadow: inset 0 0 0 2px $shades1\n            background: $n\n            +dark\n                box-shadow: inset 0 0 0 2px $n5\n                background: $n8\n                color: $n1\n            &:before\n                transform: rotate(180deg)\n        .body\n            visibility: visible\n            opacity: 1\n            transform: translateY(0)\n    &.small\n        .head\n            height: 40px\n            padding: 0 40px 0 16px\n            line-height: 40px\n            &:before\n                width: 40px\n                background-size: 16px auto\n        .option\n            padding: 4px 16px\n\n.head\n    position: relative\n    height: 48px\n    padding: 0 48px 0 12px\n    border-radius: 12px\n    box-shadow: inset 0 0 0 2px $n3\n    font-size: 14px\n    font-weight: 600\n    line-height: 48px\n    color: $n7\n    cursor: pointer\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    user-select: none\n    transition: all .2s\n    &:before\n        content: \"\"\n        position: absolute\n        top: 0\n        right: 0\n        bottom: 0\n        width: 48px\n        background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M12.707 15.707l-.094.083a1 1 0 0 1-1.32-.083h0l-6-6-.083-.094a1 1 0 0 1 1.497-1.32h0L12 13.585l5.293-5.292.094-.083a1 1 0 0 1 1.32 1.497h0l-6 6z' fill='%236f767e'/%3E%3C/svg%3E\") no-repeat 50% 50% / 24px auto\n        transition: transform .2s\n    &:hover\n        box-shadow: inset 0 0 0 2px $shades1\n    +dark\n        box-shadow: inset 0 0 0 2px $n6\n        background: none\n        color: $n4\n        &:hover\n            box-shadow: inset 0 0 0 2px $n5\n\n.selection\n    overflow: hidden\n    text-overflow: ellipsis\n    white-space: nowrap\n\n.body\n    position: absolute\n    top: calc(100% + 2px)\n    left: 0\n    right: 0\n    padding: 8px 0\n    border-radius: 12px\n    background: $n\n    box-shadow: inset 0 0 0 2px $n3, 0 4px 12px rgba($n2, .1)\n    visibility: hidden\n    opacity: 0\n    transform: translateY(3px)\n    transition: all .2s\n    +dark\n        background: $n8\n        box-shadow: inset 0 0 0 2px $n5, 0 4px 12px rgba($n8, .1)\n    &.bodyUp\n        top: auto\n        bottom: calc(100% + 2px)\n\n.option\n    padding: 8px 12px\n    +base2\n    color: $n4\n    transition: color .2s\n    cursor: pointer\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    &:hover\n        color: $n7\n        +dark\n            color: $n1\n    &.selectioned\n        color: $p1\n        +dark\n            color: $p1\n\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `rsF2XXPPwXh2xLrqYz5e`,
	"tooltip": `x5SeUnqbgpvFrLCeoRwh`,
	"dropdown": `rpd6Y0WB6Ya5FG48j17Z`,
	"active": `cil3By3nTVZfoiJ3U4GY`,
	"head": `W7YKvFicQS1yIIdCrxuC`,
	"body": `v1n0CB6Bacz5cZtVavC0`,
	"small": `i0PklF3twvLev7vQ8jOR`,
	"option": `PkJzM8GGNychNJ_wCKTs`,
	"selection": `TwVup4u8xMLxzY2fNegB`,
	"bodyUp": `LlBp5xTO5y1Pd6qM2BhW`,
	"selectioned": `tOQUCxTqXhV5MIAHEwSy`
};
export default ___CSS_LOADER_EXPORT___;
